import { TextField } from "@fluentui/react";
import React, { FC } from "react";
import moment from "moment";
import { DailyReport } from "../../models";

type Props = {
  dailyReport: DailyReport;
  onSuccess(value: string): void;
};

const DepartureButton: FC<Props> = (props: Props) => {
  const iconProps = { iconName: "DateTime" };

  return (
    <>
      {props.dailyReport.departureDate &&
        moment.utc(props.dailyReport.departureDate).local().format("ll HH:mm")}
    </>
  );
};

export default DepartureButton;
